import { render, staticRenderFns } from "./corneaMap.vue?vue&type=template&id=08ce3bf8&scoped=true&"
import script from "./corneaMap.vue?vue&type=script&lang=js&"
export * from "./corneaMap.vue?vue&type=script&lang=js&"
import style0 from "./corneaMap.vue?vue&type=style&index=0&id=08ce3bf8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ce3bf8",
  null
  
)

export default component.exports